module.exports = __webpack_public_path__ + "img/drag-and-drop.da5f97ae.svg";